import Vue from 'vue'
import Vuex from 'vuex'

import User from './modules/user'
import Breadcrumb from './modules/breadcrumb'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        User,
        Breadcrumb
    }
})

export default store
